module.exports = __webpack_public_path__ + "static/media/3DSkin.07c5c8f8.png";